module.exports = __webpack_public_path__ + "img/origa-gif.79d58c89.gif";